import { ButtonTheme, TextAlignment } from '@philips-emr/tws-constants';
import { AwesomeEvent, ComponentAPI, Value } from '@philips-emr/tws-core';
import { Changeable, ChangeEventListener } from '@philips-emr/tws-core/lib/component/types';

class SegmentedControlAPI extends ComponentAPI implements Changeable<Record<string, Value>[]> {
  /** @event */
  @AwesomeEvent
  onChange = new ChangeEventListener<Record<string, Value>[]>();

  getValue(): Record<string, Value>[] {
    return this.state.value;
  }

  setValue(value: Record<string, Value>[]): void {
    const { value: oldValue } = this.state;
    this.setState({ value });

    this.onChange.fire({ value, oldValue });
  }

  getData(): Record<string, Value>[] {
    return this.state.data;
  }

  setData(data: Record<string, Value>[]): void {
    this.setState({ data });
  }

  isMultiSelect(): boolean {
    return this.state.multiSelect;
  }

  setMultiSelect(multiSelect: boolean): void {
    this.setState({ multiSelect });
  }

  isAtLeastOne(): boolean {
    return this.state.atLeastOne;
  }

  setAtLeastOne(atLeastOne: boolean): void {
    this.setState({ atLeastOne });
  }

  isExpandToFill(): boolean {
    return this.state.expandToFill;
  }

  setExpandToFill(expandToFill: boolean): void {
    this.setState({ expandToFill });
  }

  getAlignment(): TextAlignment {
    return this.state.alignment;
  }

  setAlignment(alignment: TextAlignment): void {
    this.setState({ alignment });
  }

  getTheme(): ButtonTheme {
    return this.state.theme;
  }

  setTheme(theme: ButtonTheme): void {
    this.setState({ theme });
  }

  getItemWidth(): number {
    return this.state.itemWidth;
  }

  setItemWidth(itemWidth: number): void {
    this.setState({ itemWidth });
  }
}

export default SegmentedControlAPI;
